  let questionses = document.querySelectorAll(".questionses");
  questionses.forEach(questionses => {
    questionses.addEventListener("click", event => {
      const active = document.querySelector(".questionses.active");
      if (active && active !== questionses) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionses.classList.toggle("active");
      const answerses = questionses.nextElementSibling;
      if (questionses.classList.contains("active")) {
        answerses.style.maxHeight = answerses.scrollHeight + "px";
      } else {
        answerses.style.maxHeight = 0;
      }
    })
  })